import * as THREE from 'three';
import { InteractiveStar } from './InteractiveStar.js';

const SKY_RADIUS = 800;

function azAlt(azDeg, altDeg) {
  const az = (azDeg * Math.PI) / 180;
  const alt = (altDeg * Math.PI) / 180;
  const cosAlt = Math.cos(alt);
  return new THREE.Vector3(
    SKY_RADIUS * cosAlt * Math.sin(az),
    SKY_RADIUS * Math.sin(alt),
    -SKY_RADIUS * cosAlt * Math.cos(az),
  );
}

const RADIO_STARS_CARD = `
  <h2>The Radio Stars</h2>
  <div class="label">BTS - seven members, seven stars</div>

  <p>Seven members. Seven stars. You already know.</p>

  <hr>

  <p>There is a real scientific program called SETI - the Search for Extra-Terrestrial Intelligence. For decades, they have been pointing radio telescopes at the sky, listening to stars, hoping to find a signal. A pattern. Something that sounds like music coming from somewhere out there.</p>

  <p>They have not found it yet.</p>

  <p>They should have just asked you. You have been receiving signals from seven stars.</p>

  <hr>

  <p>Some of your all time favs:</p>

  <div class="friends">
    <div class="friend">Body to Body</div>
    <div class="friend">Cypher 4</div>
    <div class="friend">FAKE LOVE<em>rocking vibe mix</em></div>
    <div class="friend">Still With You<em>jung kook</em></div>
    <div class="friend">NUEVAYoL<em>bad bunny</em></div>
    <div class="friend">Heat Waves<em>slowed</em></div>
    <div class="friend">Belly Dancer</div>
    <div class="friend">Blank Space<em>taylor swift</em></div>
    <div class="friend">Wildest Dreams<em>taylor swift</em></div>
  </div>

`;

/**
 * The Radio Stars Constellation - 7 stars for the 7 members of BTS.
 *
 * Soft purple-pink (BTS Army color), arranged in a tight curve in the
 * northeast sky. Each star is independently clickable but they all open
 * the same Radio Stars card. Hover any one to brighten the connecting
 * lines (same hover-glow trick as the Family Constellation).
 *
 * Mikrokosmos is held back from the song list - it surfaces at the
 * finale. The card hints at it: "There is one more song that should be
 * in this constellation but isn't."
 */
export function createRadioStars({ onClick }) {
  const center = azAlt(145, -25); // south-southeast, well below horizon
  const offsetScale = 2;

  // 7 positions in a gentle curve, like dancers in formation
  const offsets = [
    new THREE.Vector3(-36, 6, 0),  // Jin
    new THREE.Vector3(-24, 1, 0),  // RM
    new THREE.Vector3(-12, -3, 0), // Suga
    new THREE.Vector3(0, -4, 0),   // J-Hope
    new THREE.Vector3(12, -3, 0),  // Jimin
    new THREE.Vector3(24, 1, 0),   // V
    new THREE.Vector3(36, 6, 0),   // Jungkook
  ].map((v) => v.multiplyScalar(offsetScale));

  const positions = offsets.map((o) => center.clone().add(o));

  const stars = positions.map((pos, i) => new InteractiveStar({
    position: pos,
    color: 0xd0a8e8,
    glowColor: '200, 160, 220',
    scale: 18,
    pulseSpeed: 0.6 + i * 0.08,   // slightly different per star - organic feel
    pulseAmount: 0.08,
    initialPhase: i * 0.7,        // staggered, out of sync
    discoveryId: 'radio-stars',
    category: 'hobbies',
    cardHTML: RADIO_STARS_CARD,
    onClick,
  }));

  // Curve lines connecting adjacent stars
  const linePoints = [];
  for (let i = 0; i < positions.length - 1; i++) {
    linePoints.push(positions[i]);
    linePoints.push(positions[i + 1]);
  }
  const lineGeometry = new THREE.BufferGeometry().setFromPoints(linePoints);
  const lineMaterial = new THREE.LineBasicMaterial({
    color: 0xb898d0,
    transparent: true,
    opacity: 0.18,
    depthWrite: false,
  });
  const lines = new THREE.LineSegments(lineGeometry, lineMaterial);

  // Hover-glow on the constellation (same trick as the Family Constellation)
  let hoverCount = 0;
  const baseLineOpacity = 0.18;
  const hoveredLineOpacity = 0.55;

  for (const star of stars) {
    const origHover = star.onHover.bind(star);
    const origUnhover = star.onUnhover.bind(star);
    star.onHover = function () {
      origHover();
      hoverCount++;
      lineMaterial.opacity = hoveredLineOpacity;
    };
    star.onUnhover = function () {
      origUnhover();
      hoverCount = Math.max(0, hoverCount - 1);
      if (hoverCount === 0) lineMaterial.opacity = baseLineOpacity;
    };
  }

  return { stars, lines };
}
